import { Instagram, Twitter, Youtube, Send } from "lucide-react";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#0D1B1A] text-[#FDFAF5] relative overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
                <div className="grid md:grid-cols-4 gap-12">
                    <div className="md:col-span-2">
                        <div className="font-serif text-3xl font-medium">
                            Dhan<span className="text-[#D4944C]">Nniti</span>
                        </div>
                        <p className="mt-4 text-sm text-[#9FB1AE] max-w-sm leading-relaxed">
                            Wealth strategy & debt-free living, crafted for
                            Indian professionals and families. 20+ years of
                            finance expertise in every roadmap.
                        </p>
                        <div className="flex gap-4 mt-6">
                            <a
                                href="#"
                                className="w-10 h-10 rounded-full border border-[#1F3533] flex items-center justify-center hover:border-[#D4944C] hover:text-[#D4944C] transition-colors"
                                aria-label="Instagram"
                            >
                                <Instagram size={16} />
                            </a>
                            <a
                                href="#"
                                className="w-10 h-10 rounded-full border border-[#1F3533] flex items-center justify-center hover:border-[#D4944C] hover:text-[#D4944C] transition-colors"
                                aria-label="Twitter"
                            >
                                <Twitter size={16} />
                            </a>
                            <a
                                href="#"
                                className="w-10 h-10 rounded-full border border-[#1F3533] flex items-center justify-center hover:border-[#D4944C] hover:text-[#D4944C] transition-colors"
                                aria-label="YouTube"
                            >
                                <Youtube size={16} />
                            </a>
                            <a
                                href="#"
                                className="w-10 h-10 rounded-full border border-[#1F3533] flex items-center justify-center hover:border-[#D4944C] hover:text-[#D4944C] transition-colors"
                                aria-label="Telegram"
                            >
                                <Send size={16} />
                            </a>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-xs tracking-[0.2em] uppercase text-[#D4944C] mb-4">
                            Packages
                        </h4>
                        <ul className="space-y-3 text-sm text-[#C4D3D1]">
                            <li>Disha — ₹969</li>
                            <li>Niti — ₹1,969</li>
                            <li>Samvad — ₹3,969</li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-xs tracking-[0.2em] uppercase text-[#D4944C] mb-4">
                            Company
                        </h4>
                        <ul className="space-y-3 text-sm text-[#C4D3D1]">
                            <li>
                                <a
                                    href="/blog"
                                    className="hover:text-white transition-colors"
                                >
                                    Blog
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/track"
                                    className="hover:text-white transition-colors"
                                >
                                    Track Submission
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#about"
                                    className="hover:text-white transition-colors"
                                >
                                    About
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#faq"
                                    className="hover:text-white transition-colors"
                                >
                                    FAQ
                                </a>
                            </li>
                            <li>Privacy Policy</li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-[#1F3533] flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-xs text-[#758684]">
                        © {new Date().getFullYear()} DhanNniti. All rights
                        reserved.
                    </p>
                    <p className="text-xs text-[#758684] italic font-serif">
                        "Debt-free is the new wealthy."
                    </p>
                </div>
            </div>
        </footer>
    );
}
